export default "/images/vendor/flag-icons/flags/4x3/bd.svg?0ad8c443ef4d47ea04971830551cd03d";